import { Directive } from '@angular/core';

@Directive({
  selector: '[egFieldSuffixDirective]',
  standalone: false,
})
export class FieldSuffixDirective {}
